(function(root, app, overwatch) {

    var Fadein = {
        targetElements: '[data-fadein="true"]',
        fadeInClass: "fadein-animation",
        win: $(root),
        init: function() {
            this.elements = $(this.targetElements);
            this.total = this.elements.length;
            this.visible = 0;
            this.elements.addClass(this.fadeInClass);
            this.triggerFadeInOnVisibleElements();
            this.setupEvents();
        },
        setupEvents: function() {
            var self = this;
            $(root).on('scroll.fadein', _.throttle(function() {
                self.triggerFadeInOnVisibleElements();
            }, 100));
        },
        //Takes care of the fade-in as you scroll down the page
        triggerFadeInOnVisibleElements: function() {
            this.elements.each(function() {
                var $this = $(this);
                if ($this.hasClass("is-visible")) { return; }
                //Once 25% of the element is in view
                if ($.isViewable($this, { percentH: 0.25 })) {
                    $this.addClass("is-visible");
                    self.visible++;
                }
            });
            if (this.visible >= this.total) {
                $(root).off('scroll.fadein');
            }
        }
    };

    app.Fadein = Fadein;

}(window, window.app, window.overwatch));
